export default __webpack_public_path__ + "static/media/tarot.c32d2010.png";